export const categories = [
  {
    slug: 'love',
    name: '恋爱漫画',
    description: '甜蜜浪漫的恋爱故事，感受心动瞬间',
    icon: 'ri-heart-line',
    count: 128,
  },
  {
    slug: 'action',
    name: '动作漫画',
    description: '热血沸腾的战斗场面，燃爆每一页',
    icon: 'ri-sword-line',
    count: 96,
  },
  {
    slug: 'fantasy',
    name: '奇幻漫画',
    description: '穿越异世界，开启奇幻冒险之旅',
    icon: 'ri-magic-line',
    count: 87,
  },
  {
    slug: 'thriller',
    name: '悬疑漫画',
    description: '层层悬念，惊险刺激的推理故事',
    icon: 'ri-search-eye-line',
    count: 64,
  },
  {
    slug: 'comedy',
    name: '搞笑漫画',
    description: '轻松愉快的日常，笑料不断',
    icon: 'ri-emotion-laugh-line',
    count: 75,
  },
  {
    slug: 'horror',
    name: '恐怖漫画',
    description: '胆量考验，毛骨悚然的恐怖体验',
    icon: 'ri-ghost-line',
    count: 42,
  },
  {
    slug: 'school',
    name: '校园漫画',
    description: '青春校园，回忆那些年我们一起追的漫画',
    icon: 'ri-book-open-line',
    count: 58,
  },
  {
    slug: 'history',
    name: '历史漫画',
    description: '穿越时空，领略历史风云变幻',
    icon: 'ri-ancient-gate-line',
    count: 36,
  },
];